import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import 'legacy/src/utility/ListManager.scss';

const QuizItemControls = (props) => {
  const { index, isLast, moveItem, stimulusId = null } = props;

  return (
    <div className="flex flex-col gap-y-1">
      <ButtonWithIcon
        isIcon
        isNaked
        size="tiny"
        icon="keyboard_arrow_up"
        data-test-id="quiz-item-up"
        className="bg-none"
        iconClassName={cn({
          'text-gray-500': index <= 0,
        })}
        onClick={() => moveItem(index, index - 1, stimulusId)}
        accessibility={{
          title: 'Move row up',
        }}
        iconAccessibility={{
          ariaHidden: true,
        }}
        disabled={index <= 0}
      />
      <ButtonWithIcon
        isIcon
        isNaked
        size="tiny"
        icon="keyboard_arrow_down"
        data-test-id="quiz-item-down"
        className="bg-none"
        iconClassName={cn({
          'text-gray-500': isLast,
        })}
        onClick={() => moveItem(index, index + 1, stimulusId)}
        accessibility={{
          title: 'Move row down',
        }}
        iconAccessibility={{
          ariaHidden: true,
        }}
        disabled={isLast}
      />
    </div>
  );
};

QuizItemControls.propTypes = {
  index: PropTypes.number.isRequired,
  isLast: PropTypes.bool,
  moveItem: PropTypes.func.isRequired,
};

QuizItemControls.defaultProps = {
  isLast: false,
};

export default QuizItemControls;
